import React from 'react';
import AtomicButton from '../../atomic/button/Button';
import { useNavigate } from 'react-router-dom';
import { getUrlParams, getUrlPath, getUrlFullPath, removeParamFromUrl } from '../../utils/getUrls';
import BrandLogoOrange from '../brandLogo/BrandLogo_Orange';
import { isMobile } from '../../utils/ScreenSizeHelper';

const SignupHeader = () => {
  const navigate = useNavigate();
  const RedirectToLogin = () => {
    navigate('/login');
    window.location.reload();
  };
  const RedirectSignup = () => {
    navigate('/checkzipcode');
    window.location.reload();
  };

  const checkUrlPathLogin = getUrlPath() === '/login';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: 'whitesmoke',
        // backgroundColor: 'rgb(255, 122, 40)',
        backgroundColor: '#fc5d1b',
        height: '60px',
        padding: isMobile ? '0px 20px 0px 0px' : '0px 40px 0px 20px',
        fontSize: '24px',
        fontWeight: '500',
      }}
    >
      <BrandLogoOrange />
      <AtomicButton
        label={checkUrlPathLogin ? 'Sign up' : 'Login'}
        handleSubmit={checkUrlPathLogin ? RedirectSignup : RedirectToLogin}
        style={{
          backgroundColor: '#181436',
          // width: 'auto',
          minWidth: '120px',
          maxWidth: '140px',
          height: '30px',
          fontSize: isMobile ? '12px' : '16px',
        }}
        loading={false}
        disabled={false}
      />
    </div>
  );
};

export default SignupHeader;
